import React, {FC} from 'react';
import {hexowatchPackages} from '../pricing-packages';
import PricingItem from '../pricing-item';
import './styles.scss';

const PricingCardDetails: FC<any> = ({name, selectedValue, checks}) => {
  const pricingItem = hexowatchPackages(name.toUpperCase(), true);
  return (
    <div className="pricing-card position-relative m-auto">
      <div className="plan-details-card-title">{name}</div>
      {pricingItem.map((item: any) => (
        <PricingItem
          text={item.text}
          ltdPrice={''}
          ltdPriceAjusted={''}
          number={item.number}
          isBold={item.isBold}
          isChecked={item.isChecked}
          unlimited={item.unlimited}
          select={item.select}
          selectedValue={{value: selectedValue, label: checks}}
        />
      ))}
    </div>
  );
};

export default PricingCardDetails;
